<template>
    <section class="top">
        <div class="top-container" >
            <h1>{{ $t('search_h1') }}</h1>
                <div class="input-holder">
                    <input type="text" name="s"    class="search-autocomplete" v-model="search" @keyup="searchFilter" :placeholder="$t('search_placeholder')" autocomplete="off">
                    <div class="spinner-block" :class="{visible: visible_spinner}">
                        <div class="spinner-grow"  role="status">
                            <span class="sr-only">{{ $t('loading') }}</span>
                        </div>
                    </div>
                    <div class="search-results-block" v-if="showSearchSuggestions" style="">
                        <ul>
                            <li v-if="questions.length == 0" class="resultEmpty">{{ $t('no_general_info') }}</li>
                            <transition-group name="fade">
                            <li v-for="question in questions" :key="question.keyword" style="animation-duration: 0.2s">
                                <a @click.stop="showResults(question.category, question.post_slug)" :data-category="question.category" class="collapser search_result" aria-expanded="false" data-toggle="collapse" :scroll-target="question.post_slug" pid="" v-html="highlight(question)" ></a>
                            </li>
                            </transition-group>
                        </ul>
                        <router-link tag="a" :to="{name: 'searchPage',params: {lang: $route.params.lang}, hash: '#' + search}" class="s-link" >{{ $t('see_all_results') }} "{{ search }}"</router-link>
                    </div>
                </div>


            <p>
                <span>{{ $t('popular_searches') }}: </span>
                <a  @click="popularSearches" class="collapser keyword-link" aria-expanded="false" :scroll-target="$t('popular_search_keyword_1')" >{{ $t('popular_search_keyword_1') }}</a>,
                <a  @click="popularSearches" class="collapser keyword-link" aria-expanded="false" :scroll-target="$t('popular_search_keyword_2')">{{ $t('popular_search_keyword_2') }}</a>,
                <a  @click="popularSearches" class="collapser keyword-link" aria-expanded="false" :scroll-target="$t('popular_search_keyword_3')">{{ $t('popular_search_keyword_3') }}</a>,					
                <a  @click="popularSearches" class="collapser keyword-link" aria-expanded="false" :scroll-target="$t('popular_search_keyword_4')">{{ $t('popular_search_keyword_4') }}</a>				
                <!-- <a  @click="popularSearches" class="collapser keyword-link" aria-expanded="false" :scroll-target="$t('popular_search_keyword_5')">{{ $t('popular_search_keyword_5') }}</a>		        -->
            </p>
        </div>
    </section>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
    data: () => {
        return {
            questions: [],
            search: "",
            showSearchSuggestions: false,
            visible_spinner: false
        }
    },
    computed: {
        accountSearchData: function() {
            return this.$store.state.account_category_data;
        }
    },
    watch: {
        accountSearchData: function() {
            this.searchFilter();
            this.search = "";
        }
    },
    methods: {
        searchFilter () {
            
            this.questions =[];
            let accountQuestions = Object.values(this.$store.getters.accountCategoryData);
            let paymentQuestions = Object.values(this.$store.getters.paymentCategoryData);
            let contentQuestions = Object.values(this.$store.getters.contentCategoryData);
            let search_keywords = this.search.split(" ");
            let questions = [];
            if(this.search.length > 0){
                this.visible_spinner = true;

                search_keywords.filter(search_keyword => {
                    accountQuestions.filter(question => {
                        question.tag_slug.filter(tag => {
                            if(tag.toLowerCase().trim() == search_keyword.toLowerCase().trim()){
                                if(!questions.includes(question)){
                                    questions.push(question)
                                }
                                
                            }
                        })
                    })
                    
                    paymentQuestions.filter(question => {
                        question.tag_slug.filter(tag => {
                            if(tag.toLowerCase().trim() == search_keyword.toLowerCase().trim()){
                                if(!questions.includes(question)){
                                    questions.push(question)
                                }
                            }
                        })
                    })

                    contentQuestions.filter(question => {
                        question.tag_slug.filter(tag => {
                            if(tag.toLowerCase().trim() == search_keyword.toLowerCase().trim()){
                                if(!questions.includes(question)){
                                    questions.push(question)
                                }
                            }
                        })
                    })
                })
                this.showSearchSuggestions = true
                this.visible_spinner = false;
                this.questions = questions;
            } else {
                    this.showSearchSuggestions = false
                }
            
        },
        highlight(question) {
            let questionTitle = question.post_title;
               return questionTitle.replace(new RegExp(this.search.trim(), "gi"), match => {
                            return '<b>' + match + '</b>';
                        });
            
        },
        showResults (category, element)  {
            // let category = event.target.getAttribute('data-category');
            // let element = event.target.getAttribute('scroll-target');
            console.log(category,element);
            this.$store.dispatch('showResults', category)
            .then(() => {
                let questions = document.getElementsByClassName('collapse_element')
                let i;
                for(i=0;i<questions.length;i++){
                    questions[i].classList.remove("show");
                    questions[i].classList.add("collapsed");
                    let id = questions[i].getAttribute('id')
                    document.querySelector("[data-target='#" + id + "']").setAttribute("aria-expanded", "false");
                } 

                this.showSearchSuggestions = !this.showSearchSuggestions;
                let openElement = document.getElementById('collapse-' + element);
                openElement.classList.add("show");
                document.querySelector("[data-target='#collapse-" + element + "']").setAttribute("aria-expanded", "true");
                
                this.search = "";
                if(this.$route.hash != "#" + element){
                    this.$router.push({ name: 'question', params: {lang: this.$route.params.lang}, hash: "#" + element});
                } else {
                    VueScrollTo.scrollTo("#" + element)
                }
                
            })
        }, 
        popularSearches () {
            let element = event.target.getAttribute('scroll-target');
            let accountQuestions = Object.values(this.$store.getters.accountCategoryData);
            let paymentQuestions = Object.values(this.$store.getters.paymentCategoryData);
            let contentQuestions = Object.values(this.$store.getters.contentCategoryData);
                
            let questions = document.getElementsByClassName('collapse_element')
           
            let i;
            for(i=0;i<questions.length;i++){
                questions[i].classList.remove("show");
                questions[i].classList.add("collapsed");
                let id = questions[i].getAttribute('id')
                document.querySelector("[data-target='#" + id + "']").setAttribute("aria-expanded", "false");
            }           
            
            accountQuestions.filter(question => {
                if(question.keyword == element){
                   this.$store.dispatch('showResults', question.category) 
                    .then(() => {
                        let openElement = document.getElementById('collapse-' + question.post_slug);
                        openElement.classList.add("show");
                        this.$router.push({ name: 'question', params: {lang: this.$route.params.lang}, hash: "#" + question.post_slug});
                    })
                }
            })
            paymentQuestions.filter(question => {
                if(question.keyword == element){
                   this.$store.dispatch('showResults', question.category)
                    .then(() => {
                        let openElement = document.getElementById('collapse-' + question.post_slug);
                        openElement.classList.add("show");
                        this.$router.push({ name: 'question', params: {lang: this.$route.params.lang}, hash: "#" + question.post_slug});
                    })
                }
            })
            contentQuestions.filter(question => {
                if(question.keyword == element){
                   this.$store.dispatch('showResults', question.category)
                    .then(() => {
                        let openElement = document.getElementById('collapse-' + question.post_slug);
                        openElement.classList.add("show");
                        this.$router.push({ name: 'question', params: { lang: this.$route.params.lang}, hash: "#" + question.post_slug});
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.search-results-block li {
    color: black;
    cursor: pointer;
}
.resultEmpty {
    text-align: left;
    font-weight: 600;
}
.highlightText {
    color: #14a7df!important;
}
.keyword-link {
    cursor: pointer;
    text-decoration: none;
    text-decoration-line: none;
    -moz-text-decoration-line: none;
}
.visible {
    visibility: visible;
    opacity: 1;
}
.search-results-block {
    display: block;
}
</style>